/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import EventCard from './EventCard';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/home-cards.scss';

const propTypes = {
    mainEvent: AppPropTypes.page,
    sideEvents: AppPropTypes.pages,
    format: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    mainEvent: null,
    sideEvents: [],
    format: null,
    className: null,
};

const HomeCards = ({ mainEvent, sideEvents, format, className }) => {
    const pageSeed = useMemo(() => {
        return Math.random() * 1000;
    }, []);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles[format]]: format !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.col}>
                <EventCard
                    className={styles.card}
                    key="card-main"
                    {...mainEvent}
                    id={mainEvent.id * 1000 + pageSeed}
                    index={0}
                />
            </div>
            <div className={styles.col}>
                {sideEvents.map((evt, i) => (
                    <EventCard
                        className={styles.card}
                        key={`card-home-${i + 1}`}
                        {...evt}
                        id={evt.id * 1000 + pageSeed}
                        index={i}
                    />
                ))}
            </div>
        </div>
    );
};

HomeCards.propTypes = propTypes;
HomeCards.defaultProps = defaultProps;

export default HomeCards;
